import { useEffect } from 'react'
import { useProcessEvent } from 'shared/hooks'
import { useClientOptions, useUser } from '@paintscout/ui-business'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useSubscriptionQuery } from '@paintscout/api'
import { getCRMAddonProductId } from '@paintscout/util'

export default function CRMTrialSync() {
  const { options, clientId } = useClientOptions()
  const { user } = useUser()
  const { crm } = useFlags()
  const trialExpiration = options.options?.crm?.trialExpiration
  const { processEvent } = useProcessEvent()

  const { data: subscriptionData, loading } = useSubscriptionQuery({
    fetchPolicy: 'network-only',
    skip: !user?.app_metadata?.company?.billingId,
    variables: {
      clientBillingId: user?.app_metadata?.company?.billingId
    }
  })

  useEffect(() => {
    if (!trialExpiration) return

    const syncCRMTrial = async () => {
      const now = Date.now()
      const subscription = subscriptionData?.subscription
      const addons = subscription?.addons
      const isOnExpiredTrial =
        trialExpiration < now &&
        crm &&
        Array.isArray(addons) &&
        !addons.some((addon) => addon.id === getCRMAddonProductId(subscription)) &&
        !loading

      if (isOnExpiredTrial) {
        await processEvent({
          type: 'set-company-feature-flag',
          provider: 'launchDarkly',
          params: {
            companyId: clientId,
            featureFlag: 'crm',
            value: false
          }
        })
      }
    }

    syncCRMTrial()
  }, [trialExpiration, crm, subscriptionData])

  return null
}
